import { create } from 'zustand';

/**
 * A single polite live region for status messages (saves, exports). Messages are
 * announced once per event — never on every pointer move (docs/11).
 */
interface AnnouncerState {
  readonly message: string;
  readonly key: number;
  announce(message: string): void;
}

export const useAnnouncer = create<AnnouncerState>((set) => ({
  message: '',
  key: 0,
  announce: (message) => set((s) => ({ message, key: s.key + 1 })),
}));

export function announce(message: string): void {
  useAnnouncer.getState().announce(message);
}
